/**
 * Consumer-only constants for the enhanced device overview (graph toggles, resizable rows).
 * Kept here so commons can stay at main; B2B does not use these.
 */
import { SensorTypes } from 'commons/src/models/commonEnums';

export const sensorRowHeightLimits = {
    min: 130,
    max: 500,
    defaultMinimized: 140,
    defaultExpanded: 215,
    minRowHeightLegendOn: 270,
    minRowHeightLegendOff: 220,
};

export const ConsumerDeviceStorageKeys = {
    showThresholdLines: 'showThresholdLines',
    scaleGraphToThresholds: 'scaleGraphToThresholds',
    sensorRowHeights: 'sensorRowHeights',
    showLegendOnLeft: 'showLegendOnLeft',
};

export const THRESHOLD_SLIDER_RANGES: Partial<Record<SensorTypes, { min: number; max: number }>> = {
    [SensorTypes.radonShortTermAvg]: { min: 0, max: 500 },
    [SensorTypes.temp]: { min: 0, max: 40 },
    [SensorTypes.co2]: { min: 400, max: 2000 },
    [SensorTypes.voc]: { min: 0, max: 3000 },
    [SensorTypes.pm1]: { min: 0, max: 50 },
    [SensorTypes.pm25]: { min: 0, max: 50 },
};
